module.exports = __webpack_public_path__ + "static/media/pfSense_step5.89cdeb56.png";